import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2.4rem;
`

export const ShowText = styled.span`
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.2rem;
  line-height: 1.33;
  letter-spacing: 0.006rem;
  text-transform: uppercase;
  color: ${(props) => transparentize(0.5, props.theme.color.white)};
`

export const ShowTextValue = styled.span`
  color: ${(props) => props.theme.color.white};
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`

const PagesWrapper = css`
  padding: 0.2rem;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  /* background-color: ${(props) => props.theme.color.pageBg};
  border-radius: 100rem; */
`

export const PagesMobileWrapper = styled.div`
  ${PagesWrapper};
  display: flex;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: none;
  `};
`

export const PagesDesktopWrapper = styled.div`
  ${PagesWrapper};
  display: none;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: flex;
  `};
`

export const PageItem = styled.button<{ active: boolean; disabled: boolean }>`
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.43;
  letter-spacing: -0.015rem;
  color: ${(props) => props.theme.color.white};
  background-color: ${(props) => (props.active ? transparentize(0.9, '#6C47FF') : props.theme.color.transparent)};
  border: 0.1rem solid ${(props) => props.theme.color.transparent};
  border-color: ${(props) => (props.active ? '#6C47FF' : props.theme.color.transparent)};
  border-radius: 0.6rem;
  transition: background-color 0.2s ease-in, border-color 0.2s ease-in;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: ${transparentize(0.9, '#6C47FF')};
    border-color: ${transparentize(0.8, '#6C47FF')};
  }
  ${(props) =>
    props.disabled &&
    `
     pointer-events: none;
  `}
`

export const PageItemMobile = styled(PageItem)`
  width: 17.8rem;
  white-space: nowrap;
  color: ${(props) => props.theme.color.textSecondary};
  background-color: ${(props) => props.theme.color.transparent};
`
